enum StorageKey {
	REFRESH_TOKEN = 'refreshToken',
	REMEMBER = 'remember',
	USER = 'user',
	CONTENT = 'content',
}

export default StorageKey;
